<template lang="html">
  <div :class="['page-head',headtype]">
      <div class="head-left">
           <van-icon @click="pageBack" class="icon" class-prefix="iconfont" name="back" />
      </div>


      <div class="page-name">
          <slot></slot>
      </div>
      <SubItem class="subNavs" ref="subItem" :itemArrs="subArrs" labelType="seek" @itemSelect="subSelect">
          <div class="head-right" @click="subOpen">
              <van-icon class="icon" class-prefix="iconfont" name="more2" />
          </div>
      </SubItem>

 </div>
</template>

<script>
import SubItem from "@/components/subItem";
export default {
     props:['headtype'],
     components:{
         SubItem
     },
     data(){
         return{
             subArrs:['唱片中心','音乐检索','中国戏曲','中国曲艺','民族歌曲','民间器乐','歌舞音乐','我的音网'],
         }
     },
     methods:{
         pageBack:function(){
             this.go(-1);
         },
         subSelect:function(e){
             if(e.inx == 0){
                  this.push('index');
             }else if(e.inx == 1){
                  this.push('seek');
             }else if(e.inx >= 2 && e.inx < 7){
                  let urlArrs = [
                      { classId:1090,classText:'全部中国戏曲' },
                      { classId:1093,classText:'全部中国曲艺' },
                      { classId:1091,classText:'全部民族歌曲' },
                      { classId:1094,classText:'全部民间器乐' },
                      { classId:1092,classText:'全部歌舞音乐' }
                  ]

                  let nowClass = urlArrs[e.inx - 2];
                  let query = {
                     classId:nowClass.classId,
                     classText:nowClass.classText,
                     postKey:'classifyList',
                     classType:1
                  };
                  this.push({
                       path:'seek',
                       query
                  });

                  if(this.$route.name == 'seek'){
                      this.$emit('goFrash');
                  }
             }else if(e.inx == 7){
                  this.push('me');
             }
         },
         subOpen:function(){
             this.$refs.subItem.show();
         },
     },
     mounted:function(){

     }
}
</script>

<style lang="css">

/* 头部 */

.page-head{
    height: 45px;
    display: flex;
    align-items: center;
    background: white;
    position: relative;
    z-index: 9;
}

.head-left,
.head-right{
    width:45px;
    height: 45px;
}

.head-left{
    display: flex;
    align-items: center;
}

.head-left .icon{
    font-size: 18px;
    margin-left: 10px;
}

.head-right{
    display: flex;
    align-items: center;
}

.head-right .icon{
   font-size: 24px;
   margin-left: 10px;
   margin-top: -5px;
}

.page-head .page-name{
    flex-grow: 1;
    font-size: 16px;
    text-align: center;
}

/*- black mode -*/

.black{
    background: black;
}

.black .head-left .icon{
    color: white;
}

.black .head-right .icon{
    color: white;
}

.black .page-name{
    color: white;
}


</style>
